<template>
  <div ref="pdfview" style="background-color : #AAEEDD">
    <center>
      <table cellspacing="2" cellpadding="2" width="97%" bgcolor="#ffFFFF" style="border-spacing: 0px 40px;">
        <tr>
          <td>
            <center>
              <!-- タイトル -->
              <!-- 氏名・生年月日 -->
              <table width="100%" border="0">
                <tr>
                  <td colspan="2" style="border:0px none;border-style:none;vertical-align:bottom;">
                    <font style="font-size:1.5em;font-weight:bold;">履&nbsp;&nbsp;&nbsp;歴&nbsp;&nbsp;&nbsp;書</font>
                  </td>
                  <td colspan="2" style="text-align:right;vertical-align:bottom;border-style:none;">
                    {{ nowdate | moment("YYYY年MM月DD日") }}現在 
                  </td>
                  <td rowspan="3" class="noborder" style="width:100px;border:none;vertical-align:bottom;padding:2px;">
                    <img :src="val.myphoto.bindata" style="width:80px;">
                  </td>
                </tr>
                <tr>
                  <td class="normallbl" style="width:80px;border-style:solid none solid solid;border-width:1px;border-color:#333;">
                    <font >ふりがな </font>
                  </td>
                  <td colspan="2" style="border-style:solid solid solid none;border-width:1px;border-color:#333;">
                    {{val.fnamekana}}{{val.lnamekana}}&nbsp;
                  </td>
                  <td class="normallbl" style="width:80px;text-align:center;border-style:solid solid none solid;border-width:1px;border-color:#333;">
                    <font>性別 </font> 
                  </td>
                </tr>
                <tr>
                  <td class="normallbl" style="width:80px;border-style:solid none solid solid;border-width:1px;border-color:#333;">
                    <font>氏&emsp;名 </font>
                  </td>
                  <td colspan="2" style="border-style:solid solid solid none;border-width:1px;border-color:#333;">
                    {{val.fname}}{{val.lname}} 
                  </td>
                  <td style="width:80px;text-align:center;border-style:none solid solid solid;border:1px solid #333;">
                    {{val.sex}} 
                  </td>
                </tr>
                <tr>
                  <td class="normallbl" style="width:80px;border-style:solid none solid solid;border-width:1px;border-color:#333;">
                    <font >生年月日 </font>
                  </td>
                  <td colspan="3" style="text-align:right;border-style:solid solid solid none;border-width:1px;border-color:#333;">
                    {{val.birthdayyear + '年' + val.birthdaymonth + '月' + val.birthdayday + '日'}}生&emsp;（満{{val.age}}歳）
                  </td>
                </tr>
              </table>
              <!-- 現住所・連絡先 -->
              <table class="bordertbl">
                <tr>
                  <td class="normallbl" style="border-style:solid none solid solid">
                    <font>ふりがな </font>
                  </td>
                  <td align="left" style="border-style:solid solid solid none">
                    {{val.gen.prefnamekana}}{{val.gen.addresskana}}{{val.gen.addresskana2}}
                  </td>
                  <td class="normallbl" style="border-style:solid none solid solid">
                    <font>電話 </font> 
                  </td>
                  <td align="left" style="border-style:solid solid solid none">
                    {{val.gen.tel}} 
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="border-style:solid solid none solid">
                    <font class="normallbl" >現住所&emsp;</font><font>(〒{{val.gen.zipcode}})</font>
                  </td>
                  <td class="normallbl" colspan="2" style="border-style:solid solid none solid">
                    <font>E-mail </font> 
                  </td>
                </tr>
                <tr>
                  <td colalign="left" colspan="2" style="border-style:none solid solid solid">
                    {{val.gen.prefname}}{{val.gen.address}}{{val.gen.address2}}
                  </td>
                  <td colspan="2" style="border-style:none solid solid solid">
                    {{val.gen.email}}
                  </td>
                </tr>
                <tr>
                  <td class="normallbl" style="border-style:solid none solid solid">
                    <font>ふりがな </font>
                  </td>
                  <td align="left" style="border-style:solid solid solid none">
                    {{val.renraku.prefnamekana}}{{val.renraku.addresskana}}{{val.renraku.addresskana2}}
                  </td>
                  <td class="normallbl" style="border-style:solid none solid solid">
                    <font>電話 </font> 
                  </td>
                  <td align="left" style="border-style:solid solid solid none">
                    {{val.renraku.tel}} 
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="border-style:solid solid none solid">
                    <font class="normallbl" >連絡先&emsp;</font><font>(〒{{val.renraku.zipcode}})</font>
                  </td>
                  <td class="normallbl" colspan="2" style="border-style:solid solid none solid">
                    <font>E-mail </font> 
                  </td>
                </tr>
                <tr>
                  <td colalign="left" colspan="2" style="border-style:none solid solid solid">
                    {{val.renraku.prefname}}{{val.renraku.address}}{{val.renraku.address2}}
                  </td>
                  <td colspan="2" style="border-style:none solid solid solid">
                    {{val.renraku.email}}
                  </td>
                </tr>
              </table>
              <!-- 学歴・職歴 -->
              <table class="bordertbl">
                <tr>
                  <td class="normallbl" style="width:100px;text-align:center;">
                    <font >年</font>
                  </td>
                  <td class="normallbl" style="width:80px;text-align:center;">
                    <font >月</font>
                  </td>
                  <td class="normallbl" style="text-align:center;">
                    <font >学歴・職歴</font>
                  </td>
                </tr>
                <tr v-for="gakusyoku in val.gakusyokus" :key="gakusyoku.id" style="height:36px">
                  <td>{{gakusyoku.year}}</td>
                  <td>{{gakusyoku.month}}</td>
                  <td>{{gakusyoku.content}}</td>
                </tr>
              </table>
              <!-- 免許・資格 -->
              <table class="bordertbl">
                <tr> 
                  <td class="normallbl" style="width:100px;text-align:center;">
                    <font >年</font>
                  </td>
                  <td class="normallbl" style="width:80px;text-align:center;">
                    <font >月</font>
                  </td>
                  <td class="normallbl" style="text-align:center;">
                    <font >免許・資格</font>
                  </td>
                </tr>
                <tr v-for="menkyosikaku in val.menkyosikakus" :key="menkyosikaku.id" style="height:36px">
                  <td>{{menkyosikaku.year}}</td>
                  <td>{{menkyosikaku.month}}</td>
                  <td>{{menkyosikaku.content}}</td>
                </tr>
              </table>
            </center>
          </td>
        </tr>
      </table>
      <table cellspacing="2" cellpadding="2" width="97%" bgcolor="#FFFFFF" style="border-spacing: 0px 20px;">
        <tr>
          <td>
            <center>
              <!-- * -->
              <table class="bordertbl">
                <tr>
                  <td class="normallbl" >
                    <font >志望動機 </font>
                  </td>
                </tr>
                <tr>
                  <td style="height:380px;border-style:none solid solid solid;vertical-align:top;white-space: pre-line">
                    {{val.sibodoki}}&nbsp;
                  </td>
                </tr>
              </table>
              <table class="bordertbl">
                <tr>
                  <td class="normallbl">
                    <font >通勤時間 </font>
                  </td>
                  <td class="normallbl">
                    <font >扶養家族(配偶者を除く) </font>
                  </td>
                  <td class="normallbl">
                    <font >配偶者 </font>
                  </td>
                  <td class="normallbl">
                    <font >配偶者の扶養義務 </font>
                  </td>
                </tr>
                <tr>
                  <td>{{val.tukintimehour + ':' + val.tukintimeminute}}&nbsp;</td>
                  <td>{{val.huyonin}}人&nbsp;</td>
                  <td>{{val.haigusyaumu}}&nbsp;</td>
                  <td>{{val.haigusyahuyogimu}}&nbsp;</td>
                </tr>
              </table>
              <table class="bordertbl">
                <tr>
                  <td  class="normallbl">
                    <font >本人希望記入欄（特に待遇・職種。勤務時間・その他についての希望などがあれば記入 </font>
                  </td>
                </tr>
                <tr>
                  <td style="height:380px;text-align:left;vertical-align:top;white-space: pre-line">
                    {{val.honninkiboran}}
                  </td>
                </tr>
              </table>
            </center>
          </td>
        </tr>
      </table>
    </center>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Preview',
  props: ['val'],
  data: function() {
    return {
      nowdate: moment().format(),
    }
  },
  methods: {
  },
  filters: {
      moment: function (date) {
          return moment(date).format('YYYY年MM月DD日')
      }
  },
  computed: {
    /*
    gakusyokus1() {
        return this.val.gakusyokus.slice(0,14)
    },
    gakusyokus2() {
        return this.val.gakusyokus.slice(14,23)
    }
    */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 罫テーブル共通 */
table {
    empty-cells: show;
    width:100%;
}
th,td {
    empty-cells: show;
    height: 1.5em;
}
/* 罫線ありテーブル */
.bordertbl {
}
.bordertbl td,th {
    border:1px solid #333;
}
.border {
  border: 1px none;
}
/* 罫線なしテーブル */
.nobordertbl {
    border:0px none;
}
.nobordertbl td,th {
    border:0px none;
}
.noborder {
  border: 0px none;
}
  /* ラベル関連 */
.normallbl {
    font-weight: bolder;
  }
@media screen and (max-width: 768px) {
/* 罫線ありテーブル */
  table {
    empty-cells: show;
    width:100%;
    font-size:0.7em;
  }
  .bordertbl {
    font-size:0.7em;
  }
/* 罫線なしテーブル */
  .nobordertbl {
    font-size:0.7em;
    border:0px none;
  }
}
</style>
